module.exports = __webpack_public_path__ + "img/63_8.d69e1ef5.png";